import { TablePattern, DefaultTable, TableOptions } from 'src/app/models/table-patterns';
import { Club } from 'src/app/models/clubs.model';
import { Referee, REFEREE_TYPE_NAMES } from 'src/app/models/referee.model';
import { EventPeriod, MatchEvent } from './match-score-sheet.models';
import { Registration } from '../../registrations/models/registration.model';
import { Relation } from 'src/app/models/relations.model';
import { Entity } from 'src/app/models/entities.model';
import { Stadium } from 'src/app/models/stadium.model';
import { League } from 'src/app/models/leagues.model';
import { SportCategory } from 'src/app/models/categories.model';
import { Indexable } from 'src/app/core/models/indexable';
import { RegistrationBID } from '../../registrations/models/registration-bid.model';
import { ContributorJob } from 'src/app/models/contributor-jobs.model';
import { Championship, CovidZone, ScoresheetPartialMode } from './championship.model';
import { User } from 'src/app/models/Users';
import { BidSingleRegistration, ChampionshipBidResponse } from './bid-registration.model';
import { Competition } from './competition.model';
import { EventTemplate } from '../../scoresheet/models/event-templates.model';
import { TJDProcessComplete } from '../../tjd/models/tjd.model';

// tslint:disable: variable-name


// active, confirmed, running, Finalized, cancelled, Scoresheet(pending), Done
export type MatchStatus = 'A' | 'C' | 'R' | 'F' | 'X' | 'S' | 'D';

export const MATCH_STATUS: Indexable<MatchStatus, string> = {
  A: 'EM ABERTO',
  C: 'CONFIRMADA',
  F: 'FINALIZADA',
  R: 'EM ANDAMENTO',
  X: 'CANCELADA',
  S: 'AG. SÛMULA',
  D: 'CONCLUIDA'
};

export type MatchPopulate = 'match' | 'delegation' | 'clubs' | 'events' |
  'referees' | 'self-delegation' | 'stadium' | 'championship' | 'championship:phases'
  | 'league' | 'championship_owner_jobs' | string;

export type MatchDateChallengeStatus = 'R' | 'A' | 'J' | 'L';
export const MATCH_DATE_CHALLENGE_STATUS: Indexable<MatchDateChallengeStatus, string> = {
  R: 'Solicitado',
  A: 'Aceito',
  J: 'Rejeitado',
  L: 'Ag. Liga'
};


export class MatchSubstitution {
  club_id: number;
  position: number;
  idx: number;
  shirt_id: string;
  period: EventPeriod;

  constructor(o?: Partial<MatchSubstitution>) {
    if (o) {
      Object.assign(this, o);
    }
    this._normalize();
  }

  private _normalize() {
    const intFields = ['club_id', 'position', 'idx'];
    intFields.forEach(f => {
      if (this[f]) { this[f] = parseInt(this[f]); }
    });
  }

}
export class MatchDateChange extends DefaultTable {
  requester_id: number;
  status: 'R' | 'A' | 'J' | 'C';
  date: string;
  history: MatchDateChange[];

  constructor(o: MatchDateChange) {
    super(o);
    if (this.history) {
      this.history = this.history.map(h => h instanceof MatchDateChange ? h : new MatchDateChange(h));
    }
  }
}

export class PartialScores extends DefaultTable<PartialScores>{
  G: number;
  F: number;
  YC: number;
  RC: number;
  GC: number;

  constructor(o?: Partial<PartialScores>) {
    super(o);
    this.G = o?.G ?? 0;
    this.F = o?.F ?? 0;
    this.YC = o?.YC ?? 0;
    this.RC = o?.RC ?? 0;
    this.GC = o?.GC ?? 0;
  }

  clear() {
    this.G = 0;
    this.F = 0;
    this.YC = 0;
    this.RC = 0;
    this.GC = 0;
  }
}
export class MatchPartial extends DefaultTable<MatchPartial>{
  period: EventPeriod;
  periodName: string;
  periodColor: string;
  startedAt: string;
  endedAt: string;
  home: PartialScores;
  away: PartialScores;

  constructor(o?: Partial<MatchPartial>) {
    super(o);
    this.home = new PartialScores(o?.home);
    this.away = new PartialScores(o?.home);
    this.setPeriodName();
    this.setPeriodColor();
  }

  clear() {
    this.home.clear();
    this.away.clear();

  }

  private setPeriodName() {
    if (!this.period) {
      this.periodName = 'PARTIDA';
      return;
    }
    switch (this.period) {
      case '1':
        this.periodName = '1o TEMPO';
        break;
      case '2':
        this.periodName = '2o TEMPO';
        break;
      case 'E':
        this.periodName = 'PRORROGAÇÃO';
        break;
      case 'P':
        this.periodName = 'PENALTIS';
        break;
      case 'G':
        this.periodName = 'PARTIDA';
        break;

    }

  }

  private setPeriodColor() {
    if (this.period == '1') {
      this.periodColor = 'blue';
    } else if (this.period == '2') {
      this.periodColor = 'red';
    } else if (this.period == 'E') {
      this.periodColor = 'red';
    } else if (this.period == 'P') {
      this.periodColor = 'red';
    }
  }
}

export class MatchGlobalResult extends MatchPartial {
  hasPenalty: boolean;
  home_penalty: number;
  away_penalty: number;

  constructor(o?: Partial<MatchGlobalResult>) {
    super(o);
    this.hasPenalty = o && Object.hasKey(o, 'hasPenalty') ? o.hasPenalty : false;
    this.home_penalty = o?.home_penalty ?? 0;
    this.home_penalty = o?.home_penalty ?? 0;
  }

  clear() {
    super.clear();
    this.hasPenalty = false;
    this.home_penalty = 0;
    this.away_penalty = 0;
  }
}



export class MatchBasicInfo extends DefaultTable {
  id: number;
  match_date: string;
  home: {
    id: number;
    name: string;
    nickname: string;
    photo_url: string;
  };

  away: {
    id: number;
    name: string;
    nickname: string;
    photo_url: string;
  };

  stadium_name: string;
  stadium_place: string;

  constructor(o: Partial<MatchBasicInfo>) {
    super(o);
  }

  static fromMatch(match: Match) {
    return new MatchBasicInfo({
      id: match.id,
      match_date: match.match_date,
      stadium_name: match.stadium?.nickname ?? match.stadium?.name ?? match.stadium_name,
      stadium_place: match.stadium ? (match.stadium.city + '-' + match.stadium.state) : '',
      home: {
        id: match.home_id,
        name: match.home?.name,
        nickname: match.home?.nickname,
        photo_url: match.home?.photo_url
      },
      away: {
        id: match.away_id,
        name: match.away?.name,
        nickname: match.away?.nickname,
        photo_url: match.away?.photo_url
      }
    });
  }
}

export type MatchFinalizationType = 'N' | 'D' | 'WO' | 'TJD';

export const MATCH_FINALIZATION_TYPE: Indexable<MatchFinalizationType, string> = {
  N: 'Normal',
  D: 'Desistência de competidor',
  WO: 'WO',
  TJD: 'Partida Suspensa'
}
export class Match extends TablePattern {
  match_guid: string;
  phase_id: number;
  league_id: number;
  championship_id: number;
  is_dayoff: boolean;
  round_id: number;
  group_id: number;
  bracket_id: number;
  home_generic_id: number;
  away_generic_id: number;
  home_placeholder: string;
  away_placeholder: string;
  home_winner_of: number;
  away_winner_of: number;
  home_braket_slot: number;
  away_braket_slot: number;
  wo_winner: number;
  running: boolean;
  partial_mode: ScoresheetPartialMode;
  has_penalty: boolean;

  match_date: string;
  date_challenge: string;
  date_challenger_id: number;
  date_challenge_status: MatchDateChallengeStatus;
  data_challenge_league_aproved: boolean;
  home_date_confirmed: boolean;
  away_date_confirmed: boolean;

  home_id: number;
  away_id: number;
  home_score: number;
  away_score: number;
  home_yc: number;
  away_yc: number;
  home_rc: number;
  away_rc: number;
  home_f: number;
  away_f: number;

  stadium_id: number;
  stadium_name: string;

  representative: string;
  status: MatchStatus;

  score_home_1: number;
  score_home_2: number;
  score_home_extra: number;
  score_home_penalty: number;
  score_away_1: number;
  score_away_2: number;
  score_away_extra: number;
  score_away_penalty: number;
  game_number: string;
  audience: number;
  police_manager: string;
  police_effective: number;
  medical_name: string;
  medical_role: string;
  medical_document: string;
  home_capitain_id: number;
  away_capitain_id: number;
  address: string;
  start_period_1: string;
  end_period_1: string;
  start_period_2: string;
  end_period_2: string;
  start_period_3: string;
  end_period_3: string;
  start_period_penalty: string;
  end_period_penalty: string;
  partials: MatchPartial[];

  home_break_1: string;
  home_break_2: string;
  away_break_1: string;
  away_break_2: string;

  report: string;
  first_kick_id: number;

  substitutions: MatchSubstitution[];

  home_delegation_released?: string;
  home_staff_released?: string;
  home_medical_released?: string;
  away_delegation_released?: string;
  away_staff_released?: string;
  away_medical_released?: string;

  /** Class PhaseCompetitor */
  home_competitor: any;
  /** Class PhaseCompetitor */
  away_competitor: any;

  home?: Club;
  away?: Club;
  score_sheet_responsible?: number;

  home_name?: string;
  away_name?: string;
  homename?: string;
  awayname?: string;

  delegation?: MatchDelegation[];
  referees?: MatchReferee[];
  events?: MatchEvent[];
  stadium?: Stadium;
  category?: SportCategory;
  scoresheet_url?: string;

  league?: League;
  history?: MatchHistory[];

  /** Class Competition need to be instantiated */
  championship?: Championship;

  /** Class Championship need to be instantiated */
  competition?: Competition;

  tjd: TJDProcessComplete[];

  finalization_type?: string;
  dropping_out_id?: number;

  constructor(o?: Partial<Match>, config?: TableOptions) {
    let int: string[] = ['league_id', 'championship_id', 'round_cod', 'home_id', 'guest_id', 'stadium_id',
      'referee1_id', 'referee2_id', 'referee_noting_id', 'referee_cron_id',
      'score_home_1', 'score_home_2', 'score_home_extra', 'score_home_penalty',
      'score_guest_1', 'score_guest_2', 'score_guest_extra', 'score_guest_penalty',
      'home_capitain_id', 'guest_capitain_id', 'first_kick_id', 'home_score', 'away_score', 'home_f',
      'away_f', 'home_yc', 'away_yc', 'home_rc', 'away_rc'];

    if (config && config.int) {
      int = int.mergeUnique(...config.int);
    }
    super(o, { int });
    this._normalize();
    if (!this.partials || !Array.isArray(this.partials)) {
      this.partials = [];
    }
    this.partials = this.partials?.map(partial => new MatchPartial(partial));
  }

  static convertToMatches(matches: Match[]): Match[] {
    const r: Match[] = [];
    if (!matches) { return matches; }
    return matches.map(m => new Match(m));
  }

  private _normalize() {
    if (this.home) {
      this.home = new Club(this.home);
    }

    if (this.away) {
      this.away = new Club(this.away);
    }


    if (this.substitutions && typeof (this.substitutions) == 'string') {
      this.substitutions = JSON.parse(this.substitutions);
    }

    if (this.substitutions && Array.isArray(this.substitutions)) {
      const _s: MatchSubstitution[] = [];
      this.substitutions.forEach(s => _s.push(new MatchSubstitution(s)));
    } else {
      this.substitutions = [];
    }

  }

  isCompetitor(clubID: number) {
    return [+this.home_id, +this.away_id].includes(clubID);
  }

  isHome(clubID: number) {
    return +this.home_id == +clubID;
  }

  isAway(clubID: number) {
    return +this.away_id == +clubID;
  }

  getStatusName() {
    const status = {
      A: 'Agendada',
      C: 'Confirmado',
      Z: 'Finalizado',
      X: 'Cancelado'
    };

    return status[this.status] || null;
  }

  openScoreSheet() {
    const report_link = `${window.location.protocol}//${window.location.host}/public/match/score-sheet?match_guid=${this.match_guid}`;
    window.open(report_link, '_blank');
  }

  get homeName() {
    if (this.home) { return this.home.nickname; }
    if (this.home_name) { return this.home_name; }
    return this.home_id;
  }

  get awayName() {
    if (this.home) { return this.home.nickname; }
    if (this.home_name) { return this.home_name; }
    return this.home_id;
  }

  get guestName() {
    if (this.away) { return this.away.nickname; }
    if (this.away_name) { return this.away_name; }
    return this.away_id;
  }

  setClubs(championship: any) {

    if (!championship.competitors) { return; }

    const home = championship.competitors.find(c => c.club_id == this.home_id);
    const away = championship.competitors.find(c => c.club_id == this.away_id);

    if (home) { this.home = home.club; }
    if (away) { this.away = away.club; }

  }

  asBasicInfo(): MatchBasicInfo {
    return MatchBasicInfo.fromMatch(this);
  }

}

export class MatchDetails {
  home?: Club;
  away?: Club;
  delegation?: MatchDelegation[];
  referees?: MatchReferee[];
  events?: MatchEvent[];
  stadium?: Stadium;
  championship?: any;
  league?: League;
  competition?: any;
  substitutions?: MatchSubstitution[];
  bid?: ChampionshipBidResponse;
  match?: Match;
  event_templates?: EventTemplate[];
}


export type MatchHistoryEvent =
  'challenge_start' |
  'challenge_acepted' |
  'challenge_rejected' |
  'league_aproved' |
  'league_rejected' |
  'date_changed' |
  'delegation_changed' |
  'started' |
  'ended' |
  'scoresheet_created' |
  'scoresheet_aproved' |
  'scoresheet_rejected' |
  'message';
export class MatchHistory<T = any, E extends Entity = any> extends TablePattern {
  event: MatchHistoryEvent;
  user_id: number;
  context_id: number;
  details: T;
  message?: string;
  user?: User;
  context: E;
}

export class RegistrationJob {

  constructor(
    public jobName: string,
    public job?: ContributorJob,
    public bid?: RegistrationBID
  ) { }
}

export type MedicalAvaliationResult = 'A' | 'I';
export const MEDICAL_AVALIATION_RESULTS: Indexable<MedicalAvaliationResult, string> = {
  A: 'Apto',
  I: 'Inapto'
};

export type MatchDelegationType = 'athletes' | 'contributors' | 'referees' | 'home_contractors' | 'away_contractors' | 'league_contractors';
export class MatchDelegation<T = any, R extends Registration | RegistrationBID = any> extends TablePattern {
  registration_id: number;
  match_id: number;
  delegation_type: MatchDelegationType;
  club_id: number;
  job: string;
  entity_id: number;
  shirt_number: string;
  field_position: string;
  league_id?: number;
  zone?: CovidZone;
  job_id?: number;
  medical_avaliation_result?: MedicalAvaliationResult;
  relation_id?: number;
  travel_responsible?: boolean;
  job_ids: number[];

  relation?: Relation<Entity, T>;
  entity?: T;
  registration?: R;

  match?: Match;
  bid?: RegistrationBID[];
  club?: Club;
  league?: League;
  jobs?: RegistrationJob[];
  contributor_job?: ContributorJob;
  calculatedBID?: BidSingleRegistration<Entity>;
  constructor(o?: Partial<MatchDelegation<any, any>>, bid?: RegistrationBID[]) {
    super(o, {
      int: ['match_id', 'club_id', 'entity_id']
    });


    this._setBid(bid);
    this._setRegistrationId();

  }

  static fromRelation<T, R extends Registration | RegistrationBID>(
    relation: Relation<Entity, T>,
    match_id: number,
    delegation_type: 'athletes' | 'contributors' | 'referees',
    registrations: R[]
  ): MatchDelegation<T, R> {
    const del = new MatchDelegation<T, R>(
      {
        club_id: relation.parent_id,
        delegation_type,
        entity: relation.entity,
        entity_id: relation.child_id,
        match_id,
      }
    );

    if (delegation_type == 'athletes') {
      del.shirt_number = relation.shirt_number;
    }

    if (delegation_type == 'contributors') {
      del.job = relation.jobs;
    }
    del.relation = relation;

    if (registrations) {

      const _entityRegistrations = registrations.filter(r => {
        const _reg: Registration = (r as any).registration;
        if (+_reg.registered_id === +del.entity_id) {
          if (+_reg.billed_id === +del.club_id) {
            return true;
          }
        }
        return false;
      });

      if (_entityRegistrations && _entityRegistrations.length > 0) {
        const active = _entityRegistrations.find(er => (er as RegistrationBID).registration.status.inArray(['A', 'WB', 'WP', 'OD']));
        if (active) {
          del.registration = active;
        } else {
          del.registration = _entityRegistrations[0];
        }
      }

    }

    return del;
  }

  private _setBid(bid: RegistrationBID[]) {
    if (bid) {
      this.bid = bid.filter(b => +b.registered.id === +this.entity_id);

      // add registrationsJob
      if (this.delegation_type === 'contributors' && this.job && this.bid && this.bid.length > 0) {
        this.jobs = [];
        const jobNames = this.job.split(',').map(j => j.trim());
        jobNames.forEach(jobName => {
          const job = new RegistrationJob(jobName);
          const registration = this.bid.find(b => +b.registered.id === +this.entity_id && b.registration.job.job_name === jobName);
          if (registration) {
            job.job = registration.registration.job;
            job.bid = registration;
          }
          this.jobs.push(job);
        });
      }
    }
  }

  private _setRegistrationId() {
    if (!this.registration_id && this.registration) {
      if ((this.registration as any).registration) {
        this.registration_id = (this.registration as any).id;
      } else {
        this.registration_id = (this.registration as any).registration.id;
      }
    }
  }

}


export class MatchDelegationJob extends MatchDelegation {

  jobName?: string;

  constructor(o: Partial<MatchDelegationJob>, bid?: RegistrationBID<Entity>[]) {
    super(o, bid);
    this._setJobName();
  }

  private _setJobName() {


    switch (this.delegation_type) {
      case 'athletes': this.jobName = 'Atleta'; break;
      case 'contributors': this.jobName = this.job; break;
      case 'referees': {
        this.jobName = `Árbitro (${REFEREE_TYPE_NAMES[this.job]})`;
        break;
      }
      case 'home_contractors':
      case 'away_contractors':
      case 'league_contractors': {
        if (this.contributor_job) {
          this.jobName = this.contributor_job.job_name;
          if (this.jobName === 'custom') {
            this.jobName = this.job.capitalize();
          } else {
            if (this.job) {
              this.jobName += ` / ${this.job}`;
            }
          }
          return;
        }
      }
    }
  }


}


export class MatchReferee extends MatchDelegation<Referee> {
  delegation_type: 'referees';
  job: '1' | '2' | '3' | 'N' | 'C' | 'R';

  constructor(o?: Partial<MatchDelegation>) {
    super(o);
  }

}

